module.exports = __webpack_public_path__ + "img/imageloader.5855bf43.gif";